import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Signup.css";

const Signup = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    name: "",
    email: "",
    password: "",
    geolocation: "",
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    const response = await fetch("https://hungryhub-backend.vercel.app/api/createuser", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: credentials.name,
        email: credentials.email,
        password: credentials.password,
        location: credentials.geolocation,
      }),
    });
    const data = await response.json();

    if (!data.success) {
      alert("Enter Valid Details");
      return;
    }
    alert("Account Created Successfully");
    navigate("/login");
  };

  const onChangeHandler = (event) => {
    setCredentials({
      ...credentials,
      [event.target.name]: event.target.value,
    });
  };
  return (
    <div className="signup">
      <div className="container">
        <form className="signup-form" onSubmit={handleSubmit}>
          <h1 className="signup-header">Signup</h1>
          <input
            type="text"
            className="input-field"
            placeholder="Full Name"
            required
            name="name"
            value={credentials.name}
            onChange={onChangeHandler}
          />
          <input
            type="email"
            className="input-field"
            placeholder="Email"
            required
            name="email"
            value={credentials.email}
            onChange={onChangeHandler}
          />
          <input
            type="password"
            className="input-field"
            placeholder="Password"
            required
            name="password"
            value={credentials.password}
            onChange={onChangeHandler}
          />
          <input
            type="text"
            className="input-field"
            placeholder="Address"
            required
            name="geolocation"
            value={credentials.geolocation}
            onChange={onChangeHandler}
          />
          <button type="submit" className="signup-button">
            Sign Up
          </button>
          <Link to="/login" className="login-redirect-button">
            Already User?
          </Link>
        </form>
      </div>
    </div>
  );
};

export default Signup;
